import React, { useEffect, useState } from "react"

import { ThemeProvider } from "@mui/material"
import { theme } from './theme/theme'
import { AppSvg } from "./components"

import { Header, SpecialOffer, StandardPricing, CreditPackPricing } from "./components"
import AudienceSelection from "./components/audienceSelection"
import { GridContent } from './styles/styles'



function App() {
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState({})

	const [responses, setResponses] = useState(500)

	const [regions, setRegions] = useState([])
	const [region, setRegion] = useState(1)
	const [demographicsHome, setDemographicsHome] = useState([])

	const [cost, setCost] = useState("")
	const [costPerResponse, setCostPerResponse] = useState("")
	const [creditPackData, setCreditPackData] = useState({})

	const [isDemLangLocal, setIsDemLangLocal] = useState(false)


	const isEmptyObject = (obj) => {
		if (obj !== undefined && obj !== null && Object.keys(obj).length === 0) return true
	
		return false
	}

	useEffect(() => {
		fetch("/api/regions", {
			credentials: "include"
		})
			.then(async (response) => {
				if (!response.ok) {
					const errorMsg = await response.json()
					throw new Error(errorMsg.message)
				}
				return response.json()
			})
			.then((data) => {
				console.log('regions', data)
				setRegions(data)
			})
			.catch((error) => {
				setError({
					type: "error",
					message: error.message
				})
			})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	useEffect(() => {	
		if (regions.length > 0) {
			fetch(`/api/demographics/${region}`, { credentials: "include" }).then(async (response) => {
					if (!response.ok) {
						// If the response is not OK, read the response as JSON and throw an error
						const errorMsg = await response.json()
						throw new Error(errorMsg.message)
					}
					return response.json()
				}).then((data) => {
					setLoading(false)
					data.forEach((category) => {
						category.demographics.forEach((demographic) => {
							if (demographic.text === "Gender" || demographic.text === "Age") {
								demographic.demographic_values.forEach((value) => {
									value.selected = true
								})
							}
						})
					})
					
					console.log({data})
					setDemographicsHome(data)

				}).catch((error) => {
					console.log({error})
					setError({
						type: "error",
						message: error.message
					})
				})
		}
	}, [regions, region])


	useEffect(() => {
		setLoading(true)
		setError({})

		if (responses === "") return

		const success = (data) => {
			if (data.completes_prediction < responses) {
				setError({
					type: "warning",
					message: `The maximum number of responses available is ${data.completes_prediction} with your selection.`
				})
			}

			setCost(data.cost)
			setCostPerResponse(data.cost_per_response)
			setCreditPackData(data.credit_pack_data)
			setLoading(false)
		}

		const error = (error) => {
			setError({
				type: "error",
				message: error.message
			})

		}

		estimateAudienceCost(demographicsHome, regions, success, error)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [demographicsHome, responses])



	const estimateAudienceCost = (demographics, regions, successCallback, errorCallback) => {

		console.log({demographics, regions})
		if (demographics.length === 0) return

		const selectedRegion = regions.find((r) => r.id === region)
		const isLucidRegion = selectedRegion.audience_type_id === 3

		const ESTIMATE_URL = isLucidRegion ? "/api/estimate/lucid" : "/api/estimate/internal"
		fetch(ESTIMATE_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				demographics: demographics,
				responses,
				selectedRegion
			})
		}).then(async (response) => {
				if (!response.ok) {
					// If the response is not OK, read the response as JSON and throw an error
					const data = await response.json()
					throw new Error(data.message)
				}
				return response.json()
			})
			.then((data) => {

				if (successCallback) successCallback(data)

			}).catch((error) => {

				if (errorCallback) errorCallback(error)
		
				console.error("Error:", error)
			})
	}

	return (
		<ThemeProvider theme={theme}>
			<Header />

			<div style={{ width: '1200px', maxWidth: '100%', margin: '0 auto' }}>
				<GridContent>

					<StandardPricing
					loading={loading}
					cost={cost}
					responses={responses}
					costPerResponse={costPerResponse}
					error={error}
				/>

					{regions.length > 0 ? (
						<AudienceSelection
							regions={regions}
							region={region}
							setRegion={setRegion}
							demographicsHome={demographicsHome}
							setDemographicsHome={setDemographicsHome}
							responses={responses}
							setResponses={setResponses}
							isDemLangLocal={isDemLangLocal}
							setIsDemLangLocal={setIsDemLangLocal}
							error={error}
							estimateAudienceCost={estimateAudienceCost}
						/>
					) : null}
				</GridContent>
				</div>

	

				<div style={{width: 100, margin: '120px auto 0'}}>
				<AppSvg type={'onepulse'} />
				</div>
		

			
						{/* {error && Object.keys(error).length !== 0 && error.type !== "warning" && (
							<Grow in={true} timeout={1000}>
								<Alert severity={error.type}>{error.message}</Alert>
							</Grow>
						)} */}
			
		</ThemeProvider>
	)
}

export default App

// <div>
// {!(error && Object.keys(error).length !== 0) && !isEmptyObject(creditPackData) && 
// 	<SpecialOffer loading={loading} responses={responses} creditPackData={creditPackData} />
// }
// </div>

// {!(error && Object.keys(error).length !== 0) && creditPackData &&
// 	<CreditPackPricing loading={loading} responses={responses} creditPackData={creditPackData} />
// }
